var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ],
      staticClass: "span-top"
    },
    [
      _c("div", { staticClass: "grey-bar" }, [
        _vm._v(
          "\n    选择待抵扣商品(汇总：共" +
            _vm._s(_vm.sum_num) +
            "件，计" +
            _vm._s(_vm.sum_price) +
            "元)\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: { data: _vm.list, height: "400", border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "create_time", label: "开单时间", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "商品图片", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        directives: [{ name: "viewer", rawName: "v-viewer" }],
                        staticClass: "image-box-small"
                      },
                      [
                        _c("img", {
                          staticClass: "viewer-img",
                          attrs: { src: scope.row.goods_img }
                        })
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "goods_name",
              label: "商品名称",
              "show-overflow-tooltip": "",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "goods_no",
              label: "商品货号",
              "show-overflow-tooltip": "",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "goods_kh",
              label: "商品款号",
              "show-overflow-tooltip": "",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "price",
              label: "代采单价",
              "show-overflow-tooltip": "",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "待抵扣",
              "show-overflow-tooltip": "",
              align: "center"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(scope.row.num) +
                          " / " +
                          _vm._s(scope.row.sum_price)
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "选择使用",
              "show-overflow-tooltip": "",
              align: "center",
              width: "160"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { size: "small", max: scope.row.num, min: 0 },
                      model: {
                        value: scope.row.choose_num,
                        callback: function($$v) {
                          _vm.$set(scope.row, "choose_num", $$v)
                        },
                        expression: "scope.row.choose_num"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grey-bar" }, [
        _c("div", [
          _vm._v(
            "\n      开单金额：共" +
              _vm._s(_vm.$parent.calcTotalMap.total_num) +
              "件，计" +
              _vm._s(_vm.$parent.calcTotalMap.total_price) +
              "元\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n      选用抵扣：共" +
              _vm._s(_vm.calcSeletions.num) +
              "件，计" +
              _vm._s(_vm.calcSeletions.price) +
              "元\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-button",
            { attrs: { type: "danger" }, on: { click: _vm.cancel } },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.comfirm } },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10f8f5b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10f8f5b3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/purchaseverify/components/DedTable.vue
// module id = null
// module chunks = 